import { TicketTypes } from '@/components/ticketTypes';
import { EnumExperienceType, Experience, Session, TicketType, TicketTypeWithOptionalTicketTypes } from '@/utils/types';

interface TicketsListProps {
  selectedSession: Session | null;
  selectedSeats: string[];
  cartTicketsNumber: number;
  warnMessage: string | null;
  experience: Experience;
  disableTicketPlus: boolean;
  addToCart: (ticket: TicketTypeWithOptionalTicketTypes, amount: number, seats: string[]) => void;
  removeFromCart: (ticket: TicketType, amount: number) => void;
  isAvailableTicketToAddCart: (experienceTypes: EnumExperienceType[]) => boolean;
}

export default function TicketsList({
  selectedSession,
  selectedSeats,
  cartTicketsNumber,
  warnMessage,
  experience,
  disableTicketPlus,
  addToCart,
  removeFromCart,
  isAvailableTicketToAddCart,
}: TicketsListProps) {
  return (
    <>
      <>
        <div className='flex w-full items-center text-base font-medium max-md:flex-col max-md:items-start'>
          <h3 className='text-3xl font-bold max-sm:text-2xl'>Ingressos</h3>
          {warnMessage && <span className='ml-2 text-primary-700'>{warnMessage}</span>}
        </div>
        <TicketTypes
          disabled={!isAvailableTicketToAddCart([EnumExperienceType.MASP_ESPETACULOS_E_EVENTOS_COM_LUGAR])}
          experience={experience}
          session={selectedSession!}
          disablePlus={disableTicketPlus}
          onAddToCart={(ticket, amount) => addToCart(ticket, amount, selectedSeats)}
          onRemoveFromCart={removeFromCart}
        />
      </>
    </>
  );
}
